
import React, { Fragment } from 'react';
import { Button }from '@cmsgov/design-system';

import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// Constants

import { UPLOAD_MODAL_VIEWS } from '@constants/common/miscellaneous';


const RemoveAndHandleView = props => {
    const {
        backEndError,
        fileName,
        fileSize,
        encryptedDocumentPath,
        parentActions: {
            handleResponse,
            removalAction,
            setFileName,
            setFileSize,
            setEncryptedDocumentPath,
            toggleBackEndErrorVisibility,
            toggleView
        },
        primaryTopAnchor,
        removalPayloadComponents,
        view
    } = props;

    const {
        UPLOAD_DOCUMENT,
        REMOVE_DOCUMENT
    } = UPLOAD_MODAL_VIEWS;

    const handleRemovalClick = () => {
        if (backEndError) {
            return null;
        }
        const removalPayload = {
            ...removalPayloadComponents,
            fileName: removalPayloadComponents.fileName || fileName,
            relativePath: removalPayloadComponents.relativePath || encryptedDocumentPath,
        };
        if (!removalPayload.fileName || !removalPayload.relativePath) {
            toggleBackEndErrorVisibility('modals.remove_document.missing_information');
            return;
        }
        removalAction(removalPayload).then(res =>
            handleResponse(
                res,
                () => {
                    toggleView(UPLOAD_DOCUMENT);
                    setFileName(null);
                    setFileSize(null);
                    setEncryptedDocumentPath(null);
                    primaryTopAnchor.current.focus();
                },
                message => toggleBackEndErrorVisibility(message),
            ),
        );
    };


    return (
        <Fragment>
            <div id = 'removal-view-file-info' className = 'file-upload-area file-upload-area--removal-view'>
                <div className = 'file-upload-area__contents'>
                    <div className = 'file-upload-area__upload-graphic'>
                        <FontAwesomeIcon icon = 'file-alt' size = '3x'/>
                    </div>
                    <div className = 'file-upload-area__upload-text'>
                        { fileName }
                    </div>
                    <div className = 'file-upload-area__upload-subtext'>
                        { fileSize }
                    </div>
                    {
                        view === REMOVE_DOCUMENT &&

                        <div className = 'file-upload-area__button-area'>
                            <Button
                                className = 'usa-button gi-button gi-button__secondary'
                                onClick = { handleRemovalClick }
                            >

                                <FormattedMessage id = 'button.remove'/>
                            </Button>
                        </div>
                    }
                </div>
            </div>
        </Fragment>
    );
};

export default RemoveAndHandleView;